module.exports = __webpack_public_path__ + "16169844a213db6923d844c9acf3c8a7.png";